/**
 * How wide a strip either side of the route is read, 2 / 5 / 10 NM.
 *
 * It is a segmented control and not a select, because it **changes the answer**:
 * a 10 NM corridor finds the ridge a 2 NM one misses, and the Sicherheitshöhe
 * that follows is a different number. A pilot decision is always visible and
 * always spelled out in words — never folded into a menu where the value it is
 * set to has to be remembered.
 */

import { useT } from '../../i18n';
import { CORRIDOR_OPTIONS } from '../../terrain';

export function CorridorControl({
  value,
  onChange,
}: {
  value: number;
  onChange(nm: number): void;
}) {
  const t = useT();
  return (
    <div className="aet-corridor">
      <span className="ae-eyebrow">{t('terrain.corridor')}</span>
      <div className="ae-seg" role="group" aria-label={t('terrain.corridor.aria')}>
        {CORRIDOR_OPTIONS.map(nm => (
          <button
            key={nm}
            type="button"
            className="ae-num"
            aria-pressed={nm === value}
            onClick={() => onChange(nm)}
          >
            {t('terrain.corridor.nm', { nm })}
          </button>
        ))}
      </div>
    </div>
  );
}
